import HomePage from 'marketing/containers/home';
import PropTypes from 'prop-types';
export { HomePage };
